import { toIsoDate } from '../../../util/shared/tmc-global';

export const mtgAllPaymentTypeObj = {
  SIMPLIFILE: 'eftPayementTypeSimplifile',
  OTC: 'eftPayementTypeOtc',
  IRS: 'eftPayementTypeIrs',
  FORTE: 'eftPayementTypeForte',
  CSC: 'eftPayementTypeCsc',
  SERVICEOKLAHOMA: 'eftPayementTypeServiceOklahoma',
  OTHER: 'eftPayementTypeOther',
  CASH: 'cashAndCheckDepositBank',
  CHECK: 'cashAndCheckDepositBank',
  CREDIT: 'creditCardDepositBank',
};

export const isCscMtgTransaction = (item = {}) => Boolean(
  (item.chunkID && /^CSC_/i.test(item.chunkID))
    || item.dataSource === 'eVendor',
);

// The business date (YYYY-MM-DD) a new mortgage receipt starts on, or null when it can't be
// resolved: the global config isn't in the store yet (it has no id key until loadConfig runs),
// or mtgTax is on but no business date is configured. Same precedence as businessDate in App.vue: the
// workstation's own date when changeBussDateIndividually is on, otherwise the global one.
export const resolveMtgReceiptBusinessDate = ({
  global = {}, payment = {}, wkstBusinessDate = '', todaysDate,
} = {}) => {
  if (global.id === undefined) return null;
  if (!global.mtgTax) return toIsoDate(todaysDate);
  const override = payment.changeBussDateIndividually ? wkstBusinessDate : '';
  const businessDate = override || global.businessDate;
  return businessDate ? toIsoDate(businessDate) : null;
};

export const updateDescription = (arr = [], settingObj, bankArr) => {
  const enumValuesArr = JSON.parse(JSON.stringify(arr));
  for (const item of enumValuesArr) {
    const keyName = item.name;
    const id = settingObj[mtgAllPaymentTypeObj[keyName]];
    const bankDetails = bankArr.find((bank) => bank._id.toString() === id);
    if (bankDetails) {
      item.description = `${item.description}   ${bankDetails.altKeyBase}`;
    }
  }
  return enumValuesArr;
};

export default {};
